export default class Milestone
{

  constructor() {
    this.title = ''
    this.user_id = ''
    this.project_id = ''
    this.due_date = ''
    this.tasks = []
  }

}